import { render, staticRenderFns } from "./live-gift.vue?vue&type=template&id=1b4d1400&scoped=true&"
import script from "./live-gift.vue?vue&type=script&lang=js&"
export * from "./live-gift.vue?vue&type=script&lang=js&"
import style0 from "./live-gift.vue?vue&type=style&index=0&id=1b4d1400&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d1400",
  null
  
)

export default component.exports